module.exports = __webpack_public_path__ + "img/16d001-09.21155588.png";